import { DynamicRecommendationsCategoryValues } from '@gig/magic-sdk/dist/adapter/games/category';

function dynamicRecommendationCategories(category) {
  if (category.greSettings !== void 0) {
    return true;
  }
  if (category.subs && Array.isArray(category.subs)) {
    return category.subs.some((sub) => dynamicRecommendationCategories(sub));
  }
  return false;
}
function isDynamicRecommendationCategory(category, dynamicCategoryValues, isLoggedIn) {
  if (category.greSettings) {
    const dynamicValues = dynamicCategoryValues.split(",");
    if (dynamicValues.some((value) => category.name.includes(value))) {
      if (!isLoggedIn && category.name.includes(DynamicRecommendationsCategoryValues.USER)) {
        return false;
      }
      return true;
    }
    return false;
  }
  if (category.subs && Array.isArray(category.subs)) {
    return category.subs.some((sub) => isDynamicRecommendationCategory(sub, dynamicCategoryValues, isLoggedIn));
  }
  return false;
}

export { dynamicRecommendationCategories, isDynamicRecommendationCategory };
